import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const fingerprint = async () => {
  const html = await (await fetch("/", { cache: "no-store" })).text();
  const srcs = [...html.matchAll(/<script[^>]+src="(\/static\/[^"]+)"/g)].map((m) => m[1]);
  const lens = await Promise.all(srcs.map((s) => fetch(s, { method: "HEAD", cache: "no-store" }).then((r) => r.headers.get("content-length") || r.headers.get("etag") || "").catch(() => "")));
  return srcs.map((s, i) => `${s}:${lens[i]}`).join("|");
};

export default function useAutoUpdate() {
  const loc = useLocation(), base = useRef(null), busy = useRef(false);
  const check = async () => {
    if (busy.current || /^\/(checkout|admin)/.test(window.location.pathname)) return;
    busy.current = true;
    try {
      const f = await fingerprint();
      if (!f) return;
      if (base.current === null) base.current = f;
      else if (f !== base.current) window.location.reload();
    } catch { /* hors ligne */ }
    busy.current = false;
  };
  useEffect(() => { check(); }, [loc.pathname]); // eslint-disable-line
  useEffect(() => {
    const on = () => document.visibilityState === "visible" && check();
    document.addEventListener("visibilitychange", on); window.addEventListener("focus", on);
    return () => { document.removeEventListener("visibilitychange", on); window.removeEventListener("focus", on); };
  }, []); // eslint-disable-line
}
